'use client'

import IconArrowDown from "@/components/icons/IconArrowDown"
import { useState } from 'react'

interface SelectProps {
	options: {
		label: string
		value: string
		defaultValue?: boolean
	}[]
	onChange?: (value: any) => void
}

export default function Dropdown({ options, onChange, ...props }: SelectProps) {
	const [isOpen, setIsOpen] = useState(false)
	const [selected, setSelected] = useState(options?.find(option => option.defaultValue || options[0]))

	if (options?.length === 1) return (
			<div className="relative w-full" onMouseLeave={() => setIsOpen(false)}>
				<div
					className={`flex w-full items-center justify-between gap-8 font-400 text-sm leading-100 -tracking-10 text-left text-black dark:text-white bg-white dark:bg-black border border-black dark:border-white px-4 py-2 rounded-[8px]`}
					{...props}
				>
					{selected?.label}
				</div>
			</div>
	)

	return (
		<>
			<div className="relative w-full" onMouseLeave={() => setIsOpen(false)}>
				<button
					onClick={() => setIsOpen(!isOpen)}
					className={`flex w-full items-center justify-between gap-8 font-400 text-sm leading-100 -tracking-10 text-left text-black dark:text-white bg-white dark:bg-black border border-black dark:border-white px-4 py-2 rounded-[8px]`}
					{...props}
				>
					{selected?.label}
					<IconArrowDown className="w-[0.875em] h-[0.875em]" />
				</button>

				{isOpen && (
					<div className={`absolute top-full left-1/2 -translate-x-1/2 min-w-full pt-2`}>
						<div className="text-black dark:text-white bg-backdrop-light/90 dark:bg-backdrop-dark/90 backdrop-blur-[4px] border border-black dark:border-white rounded-[8px] overflow-clip">
							{options?.map((option, index) => (
								<button
									key={`${option?.value}-${index}`}
									className={`flex items-center justify-between gap-4 w-full ${selected?.value === option?.value ? "font-400" : "font-400"} text-sm leading-120 -tracking-10 text-left text-black dark:text-backdrop-light hover:bg-grey/10 dark:bg-black dark:hover:bg-grey-dark/10 px-4 py-2 border-t first:border-t-0 border-grey/20`}
									onClick={() => {
										setSelected(option)
										setIsOpen(false)
										onChange && onChange(option.value)
									}}
								>
									{option.label}
									<span className={`block w-1 h-1 bg-black dark:bg-white rounded-full ${selected?.value === option?.value ? "opacity-100" : "opacity-0"}`} />
								</button>
							))}
						</div>
					</div>
				)}
			</div>
		</>
	)
}
